import APIHelper from '../helpers/APIHelper';

export async function getProjectsFunction() {
  const response = await APIHelper().get('projects/list');
  if (response.error) {
    throw new Error(response.error);
  }
  console.log('GET PROJECTS RESPONSE =>', response.projects);
  return response.projects;
}

export async function searchProjectsFunction(search) {
  const response = await APIHelper().post('projects/search', null, { search });
  if (response.error) {
    throw new Error(response.error);
  }
  console.log('GET PROJECTS SEARCH RESPONSE =>', response.projects);
  return response.projects;
}

export async function findByIdProjectssFunction(project_id) {
  const response = await APIHelper().post('projects/find', null, { project_id });
  if (response.error) {
    throw new Error(response.error);
  }
  console.log('FIND BY PROJECT BY ID  RESPONSE =>', response.projects);
  return response.projects;
}

export async function addProjectFunction(projectObj) {
  const response = await APIHelper().post('projects/insert', null, { ...projectObj });
  if (response.error) {
    throw new Error(response.error);
  }
  console.log('ADD PROJECT RESPONSE =>', response.project);
  return response.project;
}

export async function updateProjectFunction(projectObj) {
  const response = await APIHelper().post('projects/update', null, { ...projectObj });
  if (response.error) {
    throw new Error(response.error);
  }
  console.log('UPDATE PROJECT RESPONSE =>', response);
  return response.status;
}

export async function deleteProjectFunction(project_id) {
  const response = await APIHelper().post('projects/delete', null, { project_id });
  if (response.error) {
    throw new Error(response.error);
  }
  console.log('DELETE RESPONSE =>', response);
  return response.status;
}
